
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { AgregarPersonaParams, AgregarPersonaResponse, BuscarPersonaParams, PersonaProps } from '../../interfaces/comun/PersonaInterface';

export const BuscarPersona = ( params: BuscarPersonaParams ) => {

    return new Promise<PersonaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Persona/BuscarPersona', params, token)
            .then( ({ data } : { data : PersonaProps[] } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const AgregarPersona = ( params: AgregarPersonaParams ) => {

    return new Promise<AgregarPersonaResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Persona/AgregarPersona', params, token)
           .then( ({ data } : { data : AgregarPersonaResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    idPersona: 0,                   
                    idTipoPersona: 0,
                    nombreCompleto: '',                  
                });
            });
        }

    });

}